import { render } from "./ManageProfiles.vue?vue&type=template&id=46b6e11e&scoped=true"
import script from "./ManageProfiles.vue?vue&type=script&lang=js"
export * from "./ManageProfiles.vue?vue&type=script&lang=js"

import "./ManageProfiles.vue?vue&type=style&index=0&id=46b6e11e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b6e11e"]])

export default __exports__